// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file shopify/v1/presentment_money_double.proto (package shopify.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file shopify/v1/presentment_money_double.proto.
 */
export const file_shopify_v1_presentment_money_double: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CilzaG9waWZ5L3YxL3ByZXNlbnRtZW50X21vbmV5X2RvdWJsZS5wcm90bxIKc2hvcGlmeS52MSI/ChZQcmVzZW50bWVudE1vbmV5RG91YmxlEg4KBmFtb3VudBgBIAEoARIVCg1jdXJyZW5jeV9jb2RlGAIgASgJQnwKDmNvbS5zaG9waWZ5LnYxQhtQcmVzZW50bWVudE1vbmV5RG91YmxlUHJvdG9QAVoELi9wYqICA1NYWKoCClNob3BpZnkuVjHKAgpTaG9waWZ5XFYx4gIWU2hvcGlmeVxWMVxHUEJNZXRhZGF0YeoCC1Nob3BpZnk6OlYxYgZwcm90bzM'
    );

/**
 * @generated from message shopify.v1.PresentmentMoneyDouble
 */
export type PresentmentMoneyDouble = Message<'shopify.v1.PresentmentMoneyDouble'> & {
    /**
     * @generated from field: double amount = 1;
     */
    amount: number;

    /**
     * @generated from field: string currency_code = 2;
     */
    currencyCode: string;
};

/**
 * Describes the message shopify.v1.PresentmentMoneyDouble.
 * Use `create(PresentmentMoneyDoubleSchema)` to create a new message.
 */
export const PresentmentMoneyDoubleSchema: GenMessage<PresentmentMoneyDouble> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_presentment_money_double, 0);
